<template>
    <card-sections :title="Lang.get('employerdashboard::pages/settings/provider.status.title')"
                   :subtitle="Lang.get('employerdashboard::pages/settings/provider.status.subtitle')"
                   :tabName="'provider'">

        <div class="row">
            <div class="col-12 h-20">
                <flash-messages></flash-messages>
                <div class="mb-3" v-if="$page.props.isCompanyProviderManually">
                    {{ Lang.get('employerdashboard::pages/settings/provider.status.manually_provider_description') }}
                </div>
                <div class="alert alert-success" v-else-if="!$page.props.problems.problem_with_provider">
                    {{
                        Lang.get(
                            'employerdashboard::pages/settings/provider.status.success_description',
                            { 'provider': $page.props.auth.companyProvider }
                        )
                    }}
                </div>
                <div class="alert alert-danger" v-for="problem in $page.props.problems.problem_with_provider">
                    {{ problem.title }}
                    <p>{{ problem.description }}</p>
                </div>

                <div v-if="isHrSwitchEnabled">
                    <a
                        :href="this.hrSwitchUrl"
                        class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4">
                        {{ Lang.get('employerdashboard::pages/settings/provider.switch.button') }}
                        >
                    </a>
                </div>

                <div class="table mt-4" v-if="this.isWebserviceProvider">
                    <h6>{{ Lang.get('employerdashboard::pages/settings/provider.token.title') }}</h6>
                    <p>{{ Lang.get('employerdashboard::pages/settings/provider.token.description') }}</p>
                    <div v-if="currentAccessToken.is_access_token">
                        <table class="mt-4 mb-4" width="100%">
                            <tr>
                                <th>
                                    {{ Lang.get('employerdashboard::pages/settings/provider.token.created_at') }}
                                </th>
                                <td>{{ currentAccessToken.created_at }}</td>
                            </tr>
                            <tr>
                                <th>
                                    {{ Lang.get('employerdashboard::pages/settings/provider.token.expires_at') }}
                                </th>
                                <td>{{ currentAccessToken.expires_at }}</td>
                            </tr>
                        </table>
                        <button class="btn btn-secondary" @click="openConfirmModal">
                            {{ Lang.get('employerdashboard::pages/settings/provider.token.refresh_now') }}
                        </button>
                    </div>
                    <div v-else="currentAccessToken">
                        <p>{{ Lang.get('employerdashboard::pages/settings/provider.token.request_info') }}</p>
                        <button class="btn btn-secondary" @click="refreshTokens">
                            {{ Lang.get('employerdashboard::pages/settings/provider.token.request') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <template>
            <!-- Refresh token confirmation modal -->
            <div class="modal fade modalCenter" id="confirmModal" tabindex="-1" role="dialog"
                 aria-labelledby="confirmModalLabel" aria-hidden="true" ref="modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="confirmModalLabel">
                                <i class="fa fa-alert"></i>
                                {{ Lang.get('employerdashboard::pages/settings/provider.token.refresh_now_title') }}?
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>
                                <strong>
                                    {{
                                        Lang.get('employerdashboard::pages/settings/provider.token.request_info_warning')
                                    }}
                                </strong>:
                                {{
                                    Lang.get('employerdashboard::pages/settings/provider.token.request_info_warning_info')
                                }}
                            </p>
                            <p>
                                {{
                                    Lang.get('employerdashboard::pages/settings/provider.token.request_info_warning_confirm')
                                }}
                            </p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                {{ Lang.get('employerdashboard::shared.cancel') }}
                            </button>
                            <button v-if="this.sending" type="button" class="btn btn-primary" disabled="disabled">
                                {{ Lang.get('employerdashboard::pages/settings/provider.token.refreshing') }}
                            </button>
                            <button v-else="this.sending" type="button" class="btn btn-primary" @click="refreshTokens">
                                {{ Lang.get('employerdashboard::pages/settings/provider.token.refresh_now') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template>
            <!-- Show new token modal -->
            <div class="modal fade modalCenter" id="tokenModal" tabindex="-1" role="dialog"
                 aria-labelledby="tokenModalLabel" aria-hidden="true" ref="modal">
                <div class="api-confirm-dialog modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="tokenModalLabel">
                                <i class="fa fa-alert"></i>
                                {{ Lang.get('employerdashboard::pages/settings/provider.token.new') }}
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>
                                {{ Lang.get('employerdashboard::pages/settings/provider.token.new_instructions') }}
                            </p>
                            <textarea @click="selectApiToken" rows="15"
                                      class="form-control js-copy-to-clipboard-contents">
                                {{ token }}
                            </textarea>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="copyToClipboard">
                                {{ Lang.get('employerdashboard::pages/settings/provider.token.copy_to_clipboard') }}
                            </button>

                            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                {{ Lang.get('employerdashboard::shared.close') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- Company files -->
        <h4 class="mt-3">{{ Lang.get('employerdashboard::pages/settings/provider.files.title') }}</h4>
        <inertia-link v-if="showFilesButton"
                      class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4"
                      :href="route('nl.employerdashboard.employees-import.overview',
                      { company_as_uuid: company_uuid, })">
            {{ Lang.get('employerdashboard::pages/settings/provider.files.view_employee_files') }}
        </inertia-link>
        <p v-else>
            {{ Lang.get('employerdashboard::pages/settings/provider.files.no_files') }}
        </p>
    </card-sections>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from "@/Shared/TextInput";
import SettingsTabs from "@/Shared/SettingsTabs";
import FlashMessages from "@/Shared/FlashMessages";
import CardSections from "./Shared/CardSections";

export default {
    metaInfo() {
        return {
            title: Lang.get('employerdashboard::pages/settings/provider.status.title'),
        }
    },
    components: {
        CardSections,
        SettingsTabs,
        TextInput,
        Layout,
        FlashMessages,
    },
    props: {
        errors: Object,
        company: Object,
        isWebserviceProvider: Boolean,
        hrSwitchUrl: String,
        currentAccessToken: Object,
        token: String,
        company_uuid: String,
        showFilesButton: Boolean,
    },
    computed: {
        isHrSwitchEnabled() {
            return this.$page.props.featureFlags.hrSwitch;
        },

    },
    methods: {
        url() {
            return location.href;
        },
        openConfirmModal() {
            $('#confirmModal').modal('show');
        },
        showNewToken() {
            $('#tokenModal').modal('show');
        },
        hideConfirmModal() {
            $('#confirmModal').modal('hide');
        },
        refreshTokens() {
            this.sending = true;
            this.$inertia.put(this.route('nl.employerdashboard.settings.provider.refresh.attempt', this.$page.props.auth.user.selected_company.uuid))
            this.showNewToken();
            this.hideConfirmModal();
        },
        copyToClipboard() {
            document.querySelector('.js-copy-to-clipboard-contents').select();
            document.execCommand('copy');
        },
        selectApiToken() {
            document.querySelector('.js-copy-to-clipboard-contents').select();
        },
    },
    data() {
        return {
            sending: false
        }
    },
    mounted() {
        if (this.token) {
            this.showNewToken();
        }
    }
}
</script>
